import $ from 'jquery';
import React from 'react';
import PropTypes from 'prop-types';

class ShowDetails extends React.Component {
    componentDidMount() {
        $(this.button).on('click', () => {
            $.post({
                url: '/product/details/',
                data: { spinach: this.props.id }
            }).then($.featherlight);
        });
    }

    render() {
        const { showShowDetailsButton } = this.props;

        if (!showShowDetailsButton) {
            return null;
        }

        return (
            <button
                className="product-tile__show-details"
                ref={ref => this.button = ref}
            >
                Show Details
            </button>
        );
    }
}

ShowDetails.propTypes = {
    id: PropTypes.string.isRequired,
    showShowDetailsButton: PropTypes.bool.isRequired,
};

export { ShowDetails };
